export const OrderComparator = (a: any, b: any) => (a.order > b.order) ? 1 : -1

export const StringCompare = (a: string, b: string) => {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
}